import { getAbbreviationOrFullIri } from 'src/utils/getAbbreviationOrFullIri';
import { COMMON_NAMESPACES } from 'src/utils/voicebox/prompts/constants';
import { VoiceboxModelSchema } from 'src/utils/voicebox/types';

export const summarizeSchemaPrompt = ({
  classIris,
  propertiesByIri,
}: VoiceboxModelSchema) => {
  const allNamespaces = {
    ...COMMON_NAMESPACES,
    // TODO are namespaces needed? i don't think so
  };

  let n = 0;
  const mappedNamespaces = Object.fromEntries(
    Object.entries(allNamespaces).map(([prefix, uri]) => {
      if (prefix === '' || COMMON_NAMESPACES[prefix]) {
        return [prefix, uri];
      }
      // use `ns${i}` format for uncommon prefixes because voicebox has trouble with their words and their meanings
      n += 1;
      return [`ns${n}`, uri];
    })
  );
  const usedPrefixes: Set<string> = new Set();
  const qname = (iri: string) => {
    const urn = getAbbreviationOrFullIri(iri, mappedNamespaces);
    // mark which prefixes are used, and don't send the unused prefixes in the legend
    const match = urn.match(/^(.*?):/);
    const prefix = match?.[1];
    if (prefix && mappedNamespaces[prefix]) {
      usedPrefixes.add(prefix);
    }
    return urn;
  };

  const properties = Object.values(propertiesByIri)
    .map(
      ({ domains, iri, ranges }) =>
        `# ${qname(iri)} has domains(${Array.from(domains.values())
          .map(qname)
          .join(', ')}) and range(s) (${Array.from(ranges.values())
          .map(qname)
          .join(', ')}).`
    )
    .join('\n');

  const classes = classIris.map(qname).join(', ');

  const legend: string[] = [];
  usedPrefixes.forEach((prefix) => {
    const uri = mappedNamespaces[prefix];
    legend.push(`# ${prefix}=${uri}`);
  });

  const prompt = `
### RDF Graph schema of the database:
#
${legend.join('\n')}
#
# Classes:
# ${classes}
#
# Properties:
${properties}
###
`.trim();

  return prompt;
};
